var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepageCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 789.03 190.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-miterlimit:10;}.cls-2,.cls-26,.cls-41{font-size:7px;fill:#313843;font-family:Montserrat-Light, Montserrat;}.cls-26,.cls-3{letter-spacing:0em;}.cls-4{letter-spacing:-0.01em;}.cls-5{letter-spacing:-0.02em;}.cls-6{letter-spacing:0.01em;}.cls-7{letter-spacing:-0.02em;}.cls-8{letter-spacing:0em;}.cls-41,.cls-9{letter-spacing:-0.01em;}.cls-10{letter-spacing:-0.02em;}.cls-11{letter-spacing:-0.01em;}.cls-12{letter-spacing:0em;}.cls-13{letter-spacing:0.01em;}.cls-14{letter-spacing:0.03em;}.cls-15{letter-spacing:-0.02em;}.cls-16{letter-spacing:-0.02em;}.cls-17{letter-spacing:-0.07em;}.cls-18{letter-spacing:0em;}.cls-19{letter-spacing:-0.01em;}.cls-20{letter-spacing:0.01em;}.cls-21{letter-spacing:-0.01em;}.cls-22{letter-spacing:-0.01em;}.cls-23{letter-spacing:0em;}.cls-24{letter-spacing:-0.03em;}.cls-25{letter-spacing:-0.07em;}.cls-27{letter-spacing:-0.03em;}.cls-28{letter-spacing:0em;}.cls-29{letter-spacing:0.03em;}.cls-30{letter-spacing:-0.01em;}.cls-31{letter-spacing:-0.01em;}.cls-32{letter-spacing:-0.02em;}.cls-33{letter-spacing:0em;}.cls-34{letter-spacing:0.01em;}.cls-35{letter-spacing:-0.04em;}.cls-36{letter-spacing:-0.02em;}.cls-37{letter-spacing:-0.01em;}.cls-38{letter-spacing:0.03em;}.cls-39{letter-spacing:0.04em;}.cls-40{letter-spacing:0.01em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "homepage2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.28 183.81 41.98 183.81 3.28 171.68 3.28 183.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.59,382.1s-.89,4.39-7.12,6.73-13.14,2.37-16.94,2.37l38.69,12.13Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.88 157.78 41.98 183.81 27.34 162.59 67.88 157.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.09,388.7s-8.93.53-15-3c0,0-5.12-2.8-5.93-8.44l-25.91,26Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.98 183.68 88.84 169.18 41.98 183.81 98.98 183.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.74,395.22s-11.8,5.33-22.94,6.53c0,0-9.51,1.32-15.57,1.45l-10.14-14.5Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.29,353.89s1.23,17.34-10.74,26.5a38,38,0,0,1-24.46,8.31l48.65,6.52Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.7,366.6l-39.41-12.71,13.45,41.33S184.14,387.54,188.7,366.6Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.24,339.69l-.08,33.41s-.23,6.36-1.57,9l40.54-4.81Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.94,328v34.08s-.06,10.39,1.19,15.22l-38.89-37.6Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.49,330.06l-32.2,23.83L188.7,366.6S194,346.66,181.49,330.06Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.86,325.61s9.75,9.06,9.43,28.28l32.2-23.83Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.27,307.75s15,2.18,27.09,9.29,15.13,13,15.13,13l-41.63-4.45Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.3,315.53s16.71-.84,26.56,10.08l-17.15-27.28Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.69 96.01 97.46 78.81 88.05 96.01 66.69 96.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.94,301h10.81s12,.34,20-2.69l-30.77,17.2Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.69 96.01 66.69 108.47 28.99 120.17 66.69 96.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.99 82.53 66.69 96.01 28.99 120.17 28.99 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.99 45.88 66.69 96.01 28.99 82.53 28.99 45.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.69 81.51 66.69 96.01 28.99 45.88 66.69 81.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97.46 78.81 114.02 88.23 114.61 106.09 97.46 78.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.99 45.88 66.69 39.21 66.69 81.51 28.99 45.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.5,242s3.74,3.65,3.74,15.22v8.14l37.7-6.68Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.69 17.43 66.69 39.21 25.25 22.52 66.69 17.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.59,222.87,50.5,242s-2.8-6.07-22-5.88Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.28 4.25 3.28 16.64 44.34 3.35 3.28 4.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.69 17.43 44.34 3.35 25.25 22.52 66.69 17.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.7 2.67 66.69 17.43 44.34 3.35 83.7 2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.94,240.84S119.63,237,105.78,237H91.94l17-14.76Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.12,283.12s-4.06,10.35-18.41,15.21l16.56,9.42Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.38,299.48l-19.26-16.36-1.85,24.63A105,105,0,0,0,160.38,299.48Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.41,267.8a33.93,33.93,0,0,1-3.29,15.32l38.49-3.25Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.38,299.48s14.13-6.44,19.23-19.61l-38.49,3.25Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.5,225s-13-3.06-33.55-2.83l18,18.65Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.79,237.88l-42.85,3L142.5,225A61.21,61.21,0,0,1,169.79,237.88Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.41,267.8s1.34-19-17.47-27l42.85-3Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.61,279.87l-35.2-12.07,25.38-29.92s10.4,7.9,11.56,20.84A36.73,36.73,0,0,1,179.61,279.87Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "405.21 183.82 443.91 183.82 405.21 171.69 405.21 183.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.53,382.11s-.89,4.39-7.12,6.72-13.14,2.38-16.94,2.38l38.69,12.13Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "469.81 157.78 443.91 183.82 429.27 162.59 469.81 157.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516,388.7s-8.94.54-15-3c0,0-5.12-2.81-5.94-8.44l-25.9,26Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "500.92 183.69 490.78 169.19 443.91 183.82 500.92 183.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M564.67,395.23s-11.79,5.33-22.94,6.52c0,0-9.51,1.32-15.56,1.45L516,388.7Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.23,353.9s1.22,17.33-10.75,26.5A38,38,0,0,1,516,388.7l48.64,6.53Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M590.63,366.61l-39.4-12.71,13.44,41.33S586.07,387.54,590.63,366.61Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.17,339.7l-.07,33.41s-.23,6.36-1.57,9l40.53-4.81Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.88,328v34.08s-.07,10.4,1.18,15.23l-38.89-37.6Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.42,330.07,551.23,353.9l39.4,12.71S596,346.66,583.42,330.07Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M541.8,325.62s9.75,9.06,9.43,28.28l32.19-23.83Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M541.21,307.76s15,2.17,27.09,9.29,15.12,13,15.12,13l-41.62-4.45Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.24,315.53s16.71-.84,26.56,10.09l-17.15-27.28Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "468.63 96.02 499.4 78.82 489.99 96.02 468.63 96.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.88,301h10.81s12,.34,20-2.69l-30.77,17.19Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "468.63 96.02 468.63 108.47 430.92 120.18 468.63 96.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "430.92 82.53 468.63 96.02 430.92 120.18 430.92 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "430.92 45.89 468.63 96.02 430.92 82.53 430.92 45.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "468.63 81.51 468.63 96.02 430.92 45.89 468.63 81.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "499.4 78.82 515.96 88.24 516.55 106.1 499.4 78.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "430.92 45.89 468.63 39.21 468.63 81.51 430.92 45.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.43,242s3.74,3.66,3.74,15.22v8.15l37.71-6.68Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "468.63 17.44 468.63 39.21 427.18 22.53 468.63 17.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.53,222.88,452.43,242s-2.8-6.06-22-5.87Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "405.21 4.26 405.21 16.65 446.27 3.36 405.21 4.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "468.63 17.44 446.27 3.36 427.18 22.53 468.63 17.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "485.63 2.68 468.63 17.44 446.27 3.36 485.63 2.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.88,240.85S521.56,237,507.72,237H493.88l17-14.77Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M543.06,283.12s-4.07,10.36-18.41,15.22l16.56,9.42Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562.32,299.48l-19.26-16.36-1.85,24.64A104.68,104.68,0,0,0,562.32,299.48Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.35,267.81a33.89,33.89,0,0,1-3.29,15.31l38.49-3.24Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562.32,299.48s14.12-6.43,19.23-19.6l-38.49,3.24Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M544.44,225s-13-3.07-33.55-2.84l18,18.66Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.73,237.88l-42.85,3L544.44,225A61.25,61.25,0,0,1,571.73,237.88Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.35,267.81s1.33-19-17.47-27l42.85-3Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M581.55,279.88l-35.2-12.07,25.38-29.93s10.4,7.91,11.55,20.85A36.77,36.77,0,0,1,581.55,279.88Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312,390.94l-16.6,14.76s18.69,2.48,32.36,0Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.09,384.62s-9.42,6.32-27.11,6.32l15.76,14.76Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,384.62s9.26,6.32,27.72,6.32l-16.6,14.76Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.09,384.62l7.3,17.24a92.09,92.09,0,0,1-18.65,3.84Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,384.62,257,393.5s13.89,9.26,38.35,12.2Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.09,384.62l39.07.62s-14.89,12.22-31.77,16.62Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.79,354.26s-5.77,20.19-23.7,30.36l39.07.62Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258,347s4.67,25.92,26.3,37.66L257,393.5Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.79,354.26l37,5.37s-8.9,17.07-21.62,25.61Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.81,324.5s-2,21.53-11,35.13l-37-5.37Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.67,313.42s-.31,28.72-5.88,40.84l48-29.76Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.24,294.49l-40.57,18.93,42.14,11.08S412.83,308.61,409.24,294.49Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.71,376.57s5.4,7.89,21.32,16.93L258,347Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.65,346.51s5.42,16.69,18.06,30.06L258,347Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.93,325.73s.84,14.84,3,21.23l-40.31-.45Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.78,313.68a98.86,98.86,0,0,0,5.87,32.83l37.28-20.78Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.22,288.07s-3.81,14.15-3.44,25.61l43.15,12.05Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.21,290a181.5,181.5,0,0,0-1.71,23.43s0,7.26.43,12.31l-39.71-37.66Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.86,289.37s2.09,16.11,1.81,24.05l40.57-18.93Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.74,268.54s-4.44,11.7-5.53,21.45l-41-1.92Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.06,260.62a84,84,0,0,1,9.8,28.75l42.38,5.12Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.74,268.54l-46.52,19.53s6-25.93,26.93-43.62Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.06,260.62l30.44-9.87s15.75,14.94,21.74,43.74Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.15,244.45l34.16,3.78s-8.91,6.78-14.57,20.31Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.43,248.19s7.67,6.61,10.63,12.43l30.44-9.87Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.16,234.24s14.22,7.72,21.34,16.51l-41.07-2.56Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.6,230.37s-15.34,7.17-22.45,14.08l34.16,3.78Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327,238.58a48.08,48.08,0,0,1,19.43,9.61l19.73-13.95Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.22,225.09s13.81,3.42,22.94,9.15L327,238.58Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.91,223.88l-8.6,24.35L264.6,230.37S276.92,225.23,284.91,223.88Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.71,237l-12.45-15.1s14.13-1.18,24.38.07Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327,238.58A70,70,0,0,0,311.71,237l11.93-15Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.22,225.09s-11.22-2.81-19.58-3.17L327,238.58Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.26,221.85,297,238.34A81.6,81.6,0,0,1,311.71,237Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.91,223.88,297,238.34l2.28-16.49S289.69,222.59,284.91,223.88Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.31,248.23s7-7.18,20.67-9.89l-12.07-14.46Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M714,390.88l-16.6,14.76s18.69,2.48,32.36,0Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.07,384.55s-9.41,6.33-27.11,6.33l15.76,14.76Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.24,384.55s9.26,6.33,27.72,6.33l-16.6,14.76Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.07,384.55l7.3,17.25a92.09,92.09,0,0,1-18.65,3.84Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.24,384.55,659,393.44s13.89,9.26,38.35,12.2Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.07,384.55l39.07.63s-14.88,12.22-31.77,16.62Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M764.77,354.2s-5.77,20.19-23.7,30.35l39.07.63Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M659.94,346.9s4.67,25.91,26.3,37.65L659,393.44Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M764.77,354.2l37,5.37s-8.9,17.07-21.62,25.61Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M812.79,324.44s-2,21.53-11,35.13l-37-5.37Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M770.65,313.36s-.31,28.72-5.88,40.84l48-29.76Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M811.23,294.43l-40.58,18.93,42.14,11.08S814.81,308.55,811.23,294.43Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.69,376.51s5.4,7.89,21.32,16.93l.93-46.54Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619.63,346.45s5.42,16.69,18.06,30.06l22.25-29.61Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M656.91,325.67s.84,14.84,3,21.23l-40.31-.45Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M613.76,313.62a98.86,98.86,0,0,0,5.87,32.83l37.28-20.78Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M617.2,288s-3.81,14.15-3.44,25.61l43.15,12.05Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M658.19,289.92a181.75,181.75,0,0,0-1.71,23.44s0,7.26.43,12.31L617.2,288Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M768.85,289.31s2.08,16.11,1.8,24.05l40.58-18.93Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M663.72,268.48s-4.44,11.7-5.53,21.44l-41-1.91Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M759.05,260.56a84.28,84.28,0,0,1,9.8,28.75l42.38,5.12Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M663.72,268.48,617.2,288s6-25.93,26.93-43.62Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M759.05,260.56l30.43-9.87s15.76,14.94,21.75,43.74Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M644.13,244.39l34.17,3.77s-8.91,6.79-14.58,20.32Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M748.41,248.13s7.67,6.61,10.64,12.43l30.43-9.87Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M768.14,234.18s14.22,7.72,21.34,16.51l-41.07-2.56Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M666.58,230.31s-15.34,7.17-22.45,14.08l34.17,3.77Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M729,238.52a48.08,48.08,0,0,1,19.43,9.61l19.73-13.95Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.2,225s13.81,3.42,22.94,9.15L729,238.52Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.9,223.82l-8.6,24.34-11.72-17.85S678.9,225.17,686.9,223.82Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M713.69,236.89l-12.45-15.1s14.13-1.19,24.38.06Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M729,238.52a70,70,0,0,0-15.29-1.63l11.93-15Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.2,225s-11.22-2.81-19.58-3.18L729,238.52Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M701.24,221.79,699,238.28a81.6,81.6,0,0,1,14.73-1.39Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.9,223.82,699,238.28l2.28-16.49S691.67,222.53,686.9,223.82Z",
    transform: "translate(-25.25 -219.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.3,248.16s7-7.18,20.66-9.88L686.9,223.82Z",
    transform: "translate(-25.25 -219.52)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.29 9.05)"
  }, "$(this).", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 22.83,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 27.55,
    y: 0
  }, "ov"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.38,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 39.56,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.2,
    y: 0
  }, "(fu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 51.42,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 56.14,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 60.07,
    y: 0
  }, "tion() { $(\u201C#id\u201D)"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 109.16,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 110.44,
    y: 0
  }, "css")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.29 17.36)"
  }, "$(this)", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 21.43,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 22.71,
    y: 0
  }, "css(\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 38.01,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 42.72,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 46.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 50.63,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.6,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 59.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 62.03,
    y: 0
  }, "ou"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 71.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.77,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 80.5,
    y: 0
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 83.24,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 87.06,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 97.56,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 100.54,
    y: 0
  }, "\u201D"), /*#__PURE__*/React.createElement("tspan", {
    x: 102.9,
    y: 0
  }, ", \u201C#00000")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(117.26 63.49)"
  }, "cus", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 11.91,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.57,
    y: 0
  }, "om"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 26.35,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 27.64,
    y: 0
  }, "css")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(106.04 25.6)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(24.81 25.6)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 4.34,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 9.05,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 13.14,
    y: 0
  }, "ci"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 18.85,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 21.57,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.33,
    y: 0
  }, ": 1; "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 34.19,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.02,
    y: 0
  }, "o")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(27.94 33.32)"
  }, "st", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 6.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.79,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 13.13,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.1,
    y: 0
  }, "e: #123")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 40.69)"
  }, "wi", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 7.86,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 12.54,
    y: 0
  }, "th: 4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 27.81,
    y: 0
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.18,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(114.03 33.32)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(117.26 40.69)"
  }, "&lt;n", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 8.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.7,
    y: 0
  }, "v&gt;&lt;a&gt;H")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(119.17 48.83)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(28.99 48.83)"
  }, "h", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 4.72,
    y: 0
  }, "eight: 31%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 56.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 86.38)"
  }, "set", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 10.31,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 14.15,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 15.98,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 23.44,
    y: 0
  }, "eout(fu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 48.65,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 53.37,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.29,
    y: 0
  }, "tion() { $(\u201C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 95.44)"
  }, "d3.sele", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 23.56,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.49,
    y: 0
  }, "tAll(\u201C#id\u201D)"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 59.69,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 60.97,
    y: 0
  }, "data(datase")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.28 183.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7"
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 1.28,
    y: 0
  }, "en"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 10.17,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.82,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 17,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.64,
    y: 0
  }, "()"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 24.14,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 25.61,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 29.69,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.38,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 35.17,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.81,
    y: 0
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 40.05,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.76,
    y: 0
  }, "wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 50.62,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 55.3,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 58.09,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 62.73,
    y: 0
  }, "\u201D"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.09,
    y: 0
  }, ", 1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 70.76,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.68,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 79.28,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 83.87,
    y: 0
  }, "x)"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 89.76,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 91.23,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 95.31,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 98,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 100.78,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 103.42,
    y: 0
  }, "(\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 108.14,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 112.86,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(111.93 71.26)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 3.98,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 7.26,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.85,
    y: 0
  }, "g wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 25.28,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.96,
    y: 0
  }, "th")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(102.97 78.96)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 3.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.64,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 10.82,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.75,
    y: 0
  }, "t x="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 26.95,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.15,
    y: 0
  }, "40")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 104.2)"
  }, "&lt;ci", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 9.69,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 12.35,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.18,
    y: 0
  }, "le "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 23.98,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 27.73,
    y: 0
  }, "x=\u201C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 111.63)"
  }, "&lt;g ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 10.56,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 14.38,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 30.96,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.33,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(27.94 159.57)"
  }, ".", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 1.4,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 4.06,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 8.13,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.22,
    y: 0
  }, "dy(fu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 29.87,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 34.59,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.51,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 151.48)"
  }, "appe", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 17.71,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 22.43,
    y: 0
  }, "d("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 29.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 32.08,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 34.74,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.28 175.75)"
  }, "if($(this)", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 27.8,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 29.27,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 33.35,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 36.04,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 38.83,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.47,
    y: 0
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 43.71,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.09,
    y: 0
  }, "dat"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 57.68,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 61.7,
    y: 0
  }, "\u201D)=="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 74.39,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 77.13,
    y: 0
  }, "1\u201D) {"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 88.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 91.03,
    y: 0
  }, "etu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 102.67,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.37,
    y: 0
  }, "n "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 111.88,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 114.44,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 117.23,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 119.92,
    y: 0
  }, "ansla")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(118.2 56.16)"
  }, "&lt;i", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 5.81,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.26,
    y: 0
  }, "g s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 23.18,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.84,
    y: 0
  }, "c="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 33.71,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.39,
    y: 0
  }, "i")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(124.58 135.76)"
  }, "cus", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 11.91,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.57,
    y: 0
  }, "om"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 26.35,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 27.64,
    y: 0
  }, "css")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(108.39 104.2)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(115.88 111.63)"
  }, "&lt;n", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 8.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.7,
    y: 0
  }, "v&gt;&lt;a&gt;H")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(121.46 120.24)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(121.46 151.56)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(118.2 158.98)"
  }, "&lt;n", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 8.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.7,
    y: 0
  }, "v&gt;&lt;a&gt;Hel")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(106.04 167.59)"
  }, "&lt;div&gt;&lt;p&gt;Hello"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(123.12 143.45)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 3.98,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 7.26,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.85,
    y: 0
  }, "g wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 25.28,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.96,
    y: 0
  }, "th=")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(123.12 126.99)"
  }, "&lt;i", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 5.81,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.26,
    y: 0
  }, "g s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 23.18,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.84,
    y: 0
  }, "c="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 33.71,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.39,
    y: 0
  }, "i")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(28.99 78.96)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 71.26)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D c")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(28.99 143.45)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 135.76)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D c")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(26.51 167.65)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "las")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 63.49)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g=\u201C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 119.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(28.99 126.99)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g=\u201C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(267.21 5.95)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(267.21 188.82)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(229.68 18.54)"
  }, "&lt;div ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 16.03,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 19.85,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 36.43,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 38.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.63,
    y: 0
  }, "ontai"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 60.37,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 65.09,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 69.27,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.25,
    y: 0
  }, "\u201D&gt;&lt;div "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 94.73,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 98.55,
    y: 0
  }, "lass=")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(229.68 174.7)"
  }, "&lt;div ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 16.03,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 19.85,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 36.43,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 38.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.63,
    y: 0
  }, "ontai"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 60.37,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 65.09,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 69.27,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.25,
    y: 0
  }, "\u201D&gt;&lt;div "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 94.73,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 98.55,
    y: 0
  }, "lass=")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(247.2 12.32)"
  }, "$(this)", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 21.43,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 22.71,
    y: 0
  }, "css(\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 38.01,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 42.72,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 46.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 50.63,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.6,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 59.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 62.03,
    y: 0
  }, "ou"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 71.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.77,
    y: 0
  }, "d-")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(247.2 182.34)"
  }, "$(this)", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 21.43,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 22.71,
    y: 0
  }, "css(\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 38.01,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 42.72,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 46.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 50.63,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.6,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 59.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 62.03,
    y: 0
  }, "ou"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 71.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.77,
    y: 0
  }, "d-")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(315.85 166.1)"
  }, "cus", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 11.91,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.57,
    y: 0
  }, "om"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 26.35,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 27.64,
    y: 0
  }, "css")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(186.51 86.38)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(186.51 102.63)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(219.3 25.6)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 4.34,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 9.05,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 13.14,
    y: 0
  }, "ci"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 18.85,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 21.57,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.33,
    y: 0
  }, ": 1; c")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(210.46 33.32)"
  }, "st", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 6.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.79,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 13.13,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.1,
    y: 0
  }, "e: #123")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(204.71 41.1)"
  }, "wi", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 7.86,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 12.54,
    y: 0
  }, "th: 4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 27.81,
    y: 0
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.18,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(185.51 94.16)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(341.42 94.16)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(202.23 150.23)"
  }, "&lt;n", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 8.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.7,
    y: 0
  }, "v&gt;&lt;a&gt;H")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(208.1 157.78)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(199.95 49.03)"
  }, "h", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 4.72,
    y: 0
  }, "eight: 31%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(196.3 56.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(194.34 134.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(324.8 157.78)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 3.98,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 7.26,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.85,
    y: 0
  }, "g wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 25.28,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.96,
    y: 0
  }, "th")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(330.57 150.71)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 3.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.64,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 10.82,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.75,
    y: 0
  }, "t x="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 26.95,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.15,
    y: 0
  }, "40")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(197.61 142.02)"
  }, "&lt;g ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 10.56,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 14.38,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 30.96,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.33,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(214.81 166.1)"
  }, "&lt;i", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 5.81,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.26,
    y: 0
  }, "g s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 23.18,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.84,
    y: 0
  }, "c="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 33.71,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.39,
    y: 0
  }, "im")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(187.8 78.96)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 37.11,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 39.75,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(187.8 110.54)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 37.11,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 39.75,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(189.8 71.26)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "ll")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(189.8 118.44)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "ll")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(192.4 63.49)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 35.15,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(341.51 86.38)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(315.85 25.6)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 4.34,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 9.05,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 13.14,
    y: 0
  }, "ci"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 18.85,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 21.57,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.33,
    y: 0
  }, ": 1; c")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(324.8 33.32)"
  }, "st", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 6.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.79,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 13.13,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.1,
    y: 0
  }, "e: #123")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(330.57 41.1)"
  }, "wi", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 7.86,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 12.54,
    y: 0
  }, "th: 4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 27.81,
    y: 0
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.18,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(335.37 49.03)"
  }, "h", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 4.72,
    y: 0
  }, "eight: 31%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(337.53 56.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(341.8 78.96)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 37.11,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 39.75,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(340.91 71.26)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "ll")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(339.48 63.49)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 35.15,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(191.4 126.12)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 35.15,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(341.71 102.63)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(339.48 134.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(335.37 142.02)"
  }, "&lt;g ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 10.56,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 14.38,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 30.96,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.33,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(340.91 110.54)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 37.11,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 39.75,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(341.61 118.44)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "ll")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(339.48 126.12)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 35.15,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(669.47 5.95)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(669.47 188.82)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(631.93 18.54)"
  }, "&lt;div ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 16.03,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 19.85,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 36.43,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 38.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.63,
    y: 0
  }, "ontai"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 60.37,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 65.09,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 69.27,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.25,
    y: 0
  }, "\u201D&gt;&lt;div "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 94.73,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 98.55,
    y: 0
  }, "lass=")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(631.93 174.7)"
  }, "&lt;div ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 16.03,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 19.85,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 36.43,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 38.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.63,
    y: 0
  }, "ontai"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 60.37,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 65.09,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 69.27,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.25,
    y: 0
  }, "\u201D&gt;&lt;div "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 94.73,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 98.55,
    y: 0
  }, "lass=")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(649.45 12.32)"
  }, "$(this)", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 21.43,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 22.71,
    y: 0
  }, "css(\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 38.01,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 42.72,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 46.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 50.63,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.6,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 59.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 62.03,
    y: 0
  }, "ou"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 71.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.77,
    y: 0
  }, "d-")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(649.45 182.34)"
  }, "$(this)", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 21.43,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 22.71,
    y: 0
  }, "css(\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 38.01,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 42.72,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 46.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 50.63,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.6,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 59.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 62.03,
    y: 0
  }, "ou"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 71.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.77,
    y: 0
  }, "d-")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(718.11 166.1)"
  }, "cus", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 11.91,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.57,
    y: 0
  }, "om"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 26.35,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 27.64,
    y: 0
  }, "css")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(588.76 86.38)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(588.76 102.63)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(621.56 25.6)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 4.34,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 9.05,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 13.14,
    y: 0
  }, "ci"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 18.85,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 21.57,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.33,
    y: 0
  }, ": 1; c")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(612.72 33.32)"
  }, "st", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 6.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.79,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 13.13,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.1,
    y: 0
  }, "e: #123")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(606.97 41.1)"
  }, "wi", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 7.86,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 12.54,
    y: 0
  }, "th: 4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 27.81,
    y: 0
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.18,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(587.76 94.16)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(743.67 94.16)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(604.49 150.23)"
  }, "&lt;n", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 8.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.7,
    y: 0
  }, "v&gt;&lt;a&gt;H")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(610.36 157.78)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(602.2 49.03)"
  }, "h", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 4.72,
    y: 0
  }, "eight: 31%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(598.56 56.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(596.6 134.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(727.06 157.78)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 3.98,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 7.26,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.85,
    y: 0
  }, "g wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 25.28,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.96,
    y: 0
  }, "th")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(732.83 150.71)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 3.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.64,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 10.82,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.75,
    y: 0
  }, "t x="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 26.95,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.15,
    y: 0
  }, "40")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(599.87 142.02)"
  }, "&lt;g ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 10.56,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 14.38,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 30.96,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.33,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(617.07 166.1)"
  }, "&lt;i", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 5.81,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.26,
    y: 0
  }, "g s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 23.18,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.84,
    y: 0
  }, "c="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 33.71,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.39,
    y: 0
  }, "im")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(590.06 78.96)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 37.11,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 39.75,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(590.06 110.54)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 37.11,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 39.75,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(592.06 71.26)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "ll")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(592.06 118.44)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "ll")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(594.66 63.49)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 35.15,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(743.76 86.38)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(718.11 25.6)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 4.34,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 9.05,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 13.14,
    y: 0
  }, "ci"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 18.85,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 21.57,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.33,
    y: 0
  }, ": 1; c")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(727.06 33.32)"
  }, "st", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 6.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.79,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 13.13,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.1,
    y: 0
  }, "e: #123")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(732.83 41.1)"
  }, "wi", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 7.86,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 12.54,
    y: 0
  }, "th: 4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 27.81,
    y: 0
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.18,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(737.63 49.03)"
  }, "h", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 4.72,
    y: 0
  }, "eight: 31%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(739.79 56.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(744.06 78.96)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 37.11,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 39.75,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(743.16 71.26)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "ll")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(741.74 63.49)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 35.15,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(593.66 126.12)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 35.15,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(743.97 102.63)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(741.74 134.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(737.63 142.02)"
  }, "&lt;g ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 10.56,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 14.38,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 30.96,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.33,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(743.16 110.54)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 37.11,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 39.75,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(743.87 118.44)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "ll")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(741.74 126.12)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 35.15,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(405.31 9.05)"
  }, "$(this).", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 22.83,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 27.55,
    y: 0
  }, "ov"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.38,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 39.56,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.2,
    y: 0
  }, "(fu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 51.42,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 56.14,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 60.07,
    y: 0
  }, "tion() { $(\u201C#id\u201D)"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 109.16,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 110.44,
    y: 0
  }, "css")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(405.31 17.36)"
  }, "$(this)", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 21.43,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 22.71,
    y: 0
  }, "css(\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 38.01,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 42.72,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 46.81,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 50.63,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.6,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 59.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 62.03,
    y: 0
  }, "ou"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 71.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.77,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 80.5,
    y: 0
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 83.24,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 87.06,
    y: 0
  }, "olo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 97.56,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 100.54,
    y: 0
  }, "\u201D"), /*#__PURE__*/React.createElement("tspan", {
    x: 102.9,
    y: 0
  }, ", \u201C#00000")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(519.28 63.49)"
  }, "cus", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 11.91,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.57,
    y: 0
  }, "om"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 26.35,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 27.64,
    y: 0
  }, "css")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(508.07 25.6)"
  }, "&lt;p&gt;Hello&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.3,
    y: 0
  }, "p&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(426.84 25.6)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 4.34,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 9.05,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 13.14,
    y: 0
  }, "ci"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 18.85,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 21.57,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.33,
    y: 0
  }, ": 1; "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 34.19,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.02,
    y: 0
  }, "o")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(429.97 33.32)"
  }, "st", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 6.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.79,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 13.13,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.1,
    y: 0
  }, "e: #123")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 40.69)"
  }, "wi", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 7.86,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 12.54,
    y: 0
  }, "th: 4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 27.81,
    y: 0
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.18,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(516.05 33.32)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(519.28 40.69)"
  }, "&lt;n", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 8.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.7,
    y: 0
  }, "v&gt;&lt;a&gt;H")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(521.19 48.83)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(431.02 48.83)"
  }, "h", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 4.72,
    y: 0
  }, "eight: 31%")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 56.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 86.38)"
  }, "set", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 10.31,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 14.15,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 15.98,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 23.44,
    y: 0
  }, "eout(fu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 48.65,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 53.37,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.29,
    y: 0
  }, "tion() { $(\u201C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 95.44)"
  }, "d3.sele", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 23.56,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.49,
    y: 0
  }, "tAll(\u201C#id\u201D)"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 59.69,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 60.97,
    y: 0
  }, "data(datase")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(405.3 183.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7"
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 1.28,
    y: 0
  }, "en"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 10.17,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.82,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 17,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.64,
    y: 0
  }, "()"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 24.14,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 25.61,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 29.69,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.38,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 35.17,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.81,
    y: 0
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 40.05,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.76,
    y: 0
  }, "wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 50.62,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 55.3,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 58.09,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 62.73,
    y: 0
  }, "\u201D"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.09,
    y: 0
  }, ", 1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 70.76,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.68,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 79.28,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 83.87,
    y: 0
  }, "x)"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 89.76,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 91.23,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 95.31,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 98,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 100.78,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 103.42,
    y: 0
  }, "(\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 108.14,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 112.86,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(513.96 71.26)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 3.98,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 7.26,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.85,
    y: 0
  }, "g wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 25.28,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.96,
    y: 0
  }, "th")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(505 78.96)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 3.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.64,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 10.82,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.75,
    y: 0
  }, "t x="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 26.95,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.15,
    y: 0
  }, "40")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 104.2)"
  }, "&lt;ci", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 9.69,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 12.35,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.18,
    y: 0
  }, "le "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 23.98,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 27.73,
    y: 0
  }, "x=\u201C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 111.63)"
  }, "&lt;g ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 10.56,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 14.38,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 30.96,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.33,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(429.97 159.57)"
  }, ".", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 1.4,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 4.06,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 8.13,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.22,
    y: 0
  }, "dy(fu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 29.87,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 34.59,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.51,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 151.48)"
  }, "appe", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 17.71,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 22.43,
    y: 0
  }, "d("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 29.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 32.08,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 34.74,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(405.3 175.75)"
  }, "if($(this)", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 27.8,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 29.27,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 33.35,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 36.04,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 38.83,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.47,
    y: 0
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 43.71,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.09,
    y: 0
  }, "dat"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 57.68,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 61.7,
    y: 0
  }, "\u201D)=="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 74.39,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 77.13,
    y: 0
  }, "1\u201D) {"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 88.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 91.03,
    y: 0
  }, "etu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 102.67,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.37,
    y: 0
  }, "n "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 111.88,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 114.44,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 117.23,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 119.92,
    y: 0
  }, "ansla")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(520.22 56.16)"
  }, "&lt;i", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 5.81,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.26,
    y: 0
  }, "g s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 23.18,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.84,
    y: 0
  }, "c="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 33.71,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.39,
    y: 0
  }, "i")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(526.61 135.76)"
  }, "cus", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 11.91,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.57,
    y: 0
  }, "om"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 26.35,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 27.64,
    y: 0
  }, "css")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(510.41 104.2)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(517.91 111.63)"
  }, "&lt;n", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 8.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.7,
    y: 0
  }, "v&gt;&lt;a&gt;H")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(523.49 120.24)"
  }, "&lt;div&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.2,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.95,
    y: 0
  }, "div&gt;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(523.49 151.56)"
  }, "&lt;div&gt;&lt;p&gt;&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.64,
    y: 0
  }, "p")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(520.22 158.98)"
  }, "&lt;n", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 8.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 12.7,
    y: 0
  }, "v&gt;&lt;a&gt;Hel")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(508.07 167.59)"
  }, "&lt;div&gt;&lt;p&gt;Hello"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(525.15 143.45)"
  }, "&lt;", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 3.98,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 7.26,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.85,
    y: 0
  }, "g wi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 25.28,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.96,
    y: 0
  }, "th=")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(525.14 126.99)"
  }, "&lt;i", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 5.81,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.26,
    y: 0
  }, "g s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 23.18,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.84,
    y: 0
  }, "c="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 33.71,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.39,
    y: 0
  }, "i")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(431.02 78.96)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 71.26)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D c")), /*#__PURE__*/React.createElement("text", {
    className: "cls-41",
    transform: "translate(431.02 143.45)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 3.82,
    y: 0
  }, "lass="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 20.4,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 22.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 26.6,
    y: 0
  }, "olo")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 135.76)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D c")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(428.54 167.65)"
  }, "id=", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 10.53,
    y: 0
  }, "\u201C"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.22,
    y: 0
  }, "nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 22.61,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.99,
    y: 0
  }, "\u201D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 34.26,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0
  }, "las")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 63.49)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g=\u201C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 119.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.58,
    y: 0
  }, "ar a, x, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 26.33,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.79,
    y: 0
  }, ", z;")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(431.02 126.99)"
  }, "o", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 4.34,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 9.06,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0
  }, "ha"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.39,
    y: 0
  }, "g=\u201C")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageCode);
export default __webpack_public_path__ + "static/media/homepage-code.9bd40a297aec8be32f529259401cfa3e.svg";
export { ForwardRef as ReactComponent };